.modalBg {
	background: #000 url(https://3k4812ts.media.zestyio.com/rls_s2_keyart_4k_no-logo.r1DvNqeCY.jpg?optimize=high)
		no-repeat center center;
	background-size: cover;
}

.modalClose {
	height: 55px;
	max-height: 55px;
	max-width: 55px;
	min-height: 55px;
	min-width: 55px;
	width: 55px;
}

.modalClose {
	background: none;
	height: 80px;
	position: fixed;
	right: 17.5%;
	top: 32.5%;
	width: 80px;
}
